import {colorPrimitive} from '../../styles/primitives/colorPrimitive';

export interface MobileSemanticStyles {
  commentBackground: string;
  commentBackgroundPressed: string;
}

export const lightMobileSemanticStyles = {
  commentBackground: colorPrimitive.alpha.black.black200,
  commentBackgroundPressed: colorPrimitive.alpha.black.black300,
} as const satisfies MobileSemanticStyles;

export const darkMobileSemanticStyles = {
  commentBackground: colorPrimitive.alpha.white.white300,
  commentBackgroundPressed: colorPrimitive.alpha.white.white400,
} as const satisfies MobileSemanticStyles;
